/* #region header */
/**************************************************************************************************
//
//  Description: Property Context
//
//  Copyright:    © 2021 Aligned Assets Limited
//
//--------------------------------------------------------------------------------------------------
//
//  Modification History:
//
//  Version Date     Modifier            Issue# Description
//#region Version 1.0.0.0 changes
//    001   13.04.21 Sean Flook         WI39345 Initial Revision.
//    002   18.06.21 Sean Flook         WI39345 Corrected spelling.
//#endregion Version 1.0.0.0 changes
//
//--------------------------------------------------------------------------------------------------
/* #endregion header */

/* #region imports */

import React from "react";

/* #endregion imports */

const PropertyContext = React.createContext();
PropertyContext.displayName = "PropertyContext";

export default PropertyContext;
